export const CHECKOUT_URL = 'https://prostho-en.impultienda.ar/checkout/'
